export default __webpack_public_path__ + "static/media/waitlist-blue.323f2b8e.svg";